import 'core-js/stable'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

import Vue from 'vue'
import App from './App'
import { store } from '@/store';
import { router } from '@/router';
import apolloProvider from '@/apollo'
import * as helpers from '@/helpers'

import { uimixin } from '@/uimixin'


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// import the component
// https://vue-treeselect.js.org/
import Treeselect from '@riophae/vue-treeselect'
Vue.component('treeselect', Treeselect)

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
Vue.component('daterangepicker', DateRangePicker)

import VCalendar from 'v-calendar';
Vue.use(VCalendar)

import VueMoment from 'vue-moment';
import Vue2Filters from 'vue2-filters'
import resize from "vue-element-resize-detector";
import VueTruncate from 'vue-truncate-filter';
import Print from 'vue-print-nb'
import wysiwyg from "vue-wysiwyg";
import VueCircle from 'vue2-circle-progress'

Vue.use(wysiwyg);

Vue.use(Print);

Vue.use(resize)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueMoment);
Vue.use(Vue2Filters)
Vue.use(VueTruncate)

Vue.use(VueCircle)

Vue.component('AutoLogout', () => import('@/pages/private/AutoLogout'));

Vue.component('Report1', () => import('@/pages/private/Apps/Reports/Components/Report1'));

Vue.component('d-table', () => import('@/pages/components/d-table.vue'));
Vue.component('e-table', () => import('@/pages/components/e-table.vue'));
Vue.component('r-table', () => import('@/pages/components/r-table.vue'));
Vue.component('r-invoice', () => import('@/pages/components/r-invoice.vue'));

import VueChartJs from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.plugins.unregister(ChartDataLabels);
Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
  color: "#FFF"
});
Vue.component("bar-chart", {
  extends: VueChartJs.Bar,
  props: ["data", "options"],
  computed: {
    chartData() {
      return this.data;
    },
    chartOptions() {
      return this.options;
    },
  },
  methods: {
    renderLineChart() {
      console.log('calling renderLineChart')
      this.renderChart(
        this.chartData,
        this.chartOptions
      );
    }
  },
  watch: {
    'data.labels': {
      deep: true,
      async handler(newVal, oldVal) {
        // this._chart.destroy();
        // this.renderChart(this.chartData, this.chartOptions);
        this.renderLineChart();
      }
    }
  }
});

Vue.component("doughnut-chart", {
  extends: VueChartJs.Doughnut,
  props: ["data", "options"],
  computed: {
    chartData() {
      return this.data;
    },
    chartOptions() {
      return this.options;
    },
  },
  methods: {
    renderLineChart() {
      console.log('calling renderLineChart')

      this.addPlugin({
        id: "centertext",

        beforeDraw: function (chart) {
          //Get ctx from string

          var ctx = chart.chart.ctx;
          var fontStyle = "Arial";
          let sum = 0;

          if (chart.data.datasets.length > 0) {
            let dataArr = chart.data.datasets[0].data;
            dataArr.map(data => {
              sum += data;
            });
          }

          var color = "#6c757d"; //"#555";
          var fontSizeToUse = 14;
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";

          const centerX = chart.chart.width / 2; //Math.round((chart.chart.width - ctx.measureText(txt).width) / 2);
          let centerY = chart.chart.height / 2 + fontSizeToUse / 2;
          centerY += 20;
          if (chart.options.legend.display) {
            centerY += -10;
          }
          // const centerY = -10 + chart.chart.height / 2 + fontSizeToUse / 2;

          ctx.font = fontSizeToUse + "px " + fontStyle;
          ctx.fillStyle = color;

          var txt = "";

          if (sum == 0) {
            txt = "No data to display";
            fontSizeToUse = 12;
          } else {
            txt = sum;
            if (chart.options.hole.text) {
              txt = chart.options.hole.text
            }
          }
          ctx.fillText(txt, centerX, centerY);
        }
      })

      this.renderChart(
        this.chartData,
        this.chartOptions
      );
    }
  },
  watch: {
    'data.labels': {
      deep: true,
      async handler(newVal, oldVal) {
        if (this.$data._chart) {
          this.$data._chart.destroy();
        }
        // this.renderChart(this.chartData, this.chartOptions);
        this.renderLineChart();
      }
    }
  }
});


// Vue.component("bar-chart", {
//   extends: VueChartJs.Bar,
//   props: ["data", "options"],
//   mounted() {
//     this.renderLineChart();
//   },
//   computed: {
//     chartData: function() {
//       return this.data;
//     }
//   },
//   methods: {
//     renderLineChart() {
//     this.renderChart(
//       {
//         labels: [
//           "January",
//           "February",
//           "March",
//           "April",
//           "May",
//           "June",
//           "July"
//         ],
//         datasets: [
//           {
//             label: "ABC",
//             backgroundColor: "#f87979",
//             data: this.chartData
//           }
//         ]
//       },
//       { responsive: true, maintainAspectRatio: false, legend: { display:false } }
//     );      
//     }
//   },
//   watch: {
//     data: function() {
//       this._chart.destroy();
//       //this.renderChart(this.data, this.options);
//       this.renderLineChart();
//     }
//   }
// });
// Filters
Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})
Vue.filter('formatTimeago', function (time) {
  switch (typeof time) {
    case 'number':
      break;
    case 'string':
      time = +new Date(time);
      break;
    case 'object':
      if (time.constructor === Date) time = time.getTime();
      break;
    default:
      time = +new Date();
  }
  var time_formats = [
    [60, 'seconds', 1], // 60
    [120, '1 minute ago', '1 minute from now'], // 60*2
    [3600, 'minutes', 60], // 60*60, 60
    [7200, '1 hour ago', '1 hour from now'], // 60*60*2
    [86400, 'hours', 3600], // 60*60*24, 60*60
    [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
    [604800, 'days', 86400], // 60*60*24*7, 60*60*24
    [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
    [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
    [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
    [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
    [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
    [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
    [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
    [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
  ];
  var seconds = (+new Date() - time) / 1000,
    token = 'ago',
    list_choice = 1;

  if (seconds == 0) {
    return 'Just now'
  }
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    token = 'from now';
    list_choice = 2;
  }
  var i = 0,
    format;
  while (format = time_formats[i++])
    if (seconds < format[0]) {
      if (typeof format[2] == 'string')
        return format[list_choice];
      else
        return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
    }
  return time;
})

Vue.directive('click-outside', {
  // When the bound element is inserted into the DOM...
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }

      console.warn(warn);
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    // add Event Listeners
    document.addEventListener("click", handler);
  },
  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
})

Vue.mixin(uimixin)

Vue.prototype.$helpers = helpers

new Vue({
  el: '#app',
  router,
  store,
  apolloProvider,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  // icons,
  template: '<App/>',
  components: {
    App
  },
  created() {
    this.$store.dispatch('currentUser')
  },
})
